import { faTrash, faPlus, faUpload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useRef, useState } from 'react';
import { Button, Col, ListGroup, Row } from 'react-bootstrap';

const DataConstants = {
  CONTENT_TYPE: 'application/pdf',
  MAX_SIZE_FILE_UPLOAD: 10485760,
};

const FormTescuchaFiles = ({ onFileAttached, onUploadAction }) => {
  const fileRef = useRef(null);
  const [files, setFiles] = useState([]);
  const [message, setMessage] = useState('');
  const [reRender, setReRender] = useState(false);

  const uploadFile = e => {
    setMessage('');
    const filesEvent = e.target.files;
    const filesArray = Object.keys(filesEvent).map(fileKey => filesEvent[fileKey]);
    const filesArrayInvalidSize = filesArray.filter(file => file.size > DataConstants.MAX_SIZE_FILE_UPLOAD);

    if (filesArrayInvalidSize.length) {
      setMessage('El tamaño de archivo excede los 10 MB');
      setReRender(true);
      return;
    }

    // reemplazo archivos si ya existian adjuntos
    const validReplacedObj = {};
    files.forEach(file => {
      validReplacedObj[file.name] = file;
    });
    filesArray.forEach(file => {
      validReplacedObj[file.name] = file;
    });

    // agregos solo archivops validos
    setFiles(Object.values(validReplacedObj).map(file => file));
    onFileAttached(Object.values(validReplacedObj).map(file => file));

    // reseteo referencia de input y re renderizo debido a bug de input
    // (bug: si se colocan los mismos archivos no dispara el evento onChange)
    fileRef.current = null;
    setReRender(true);
  };

  const removeFile = indexFile => {
    const newFiles = files.filter((file, index) => indexFile !== index);
    setFiles(newFiles);
    onFileAttached(newFiles);
  };

  const resetFiles = () => {
    fileRef.current = null;
    setFiles([]);
    setReRender(true);
  };

  useEffect(() => {
    if (reRender) {
      setReRender(false);
    }
  }, [reRender]);

  return (
    <div className="w-100">
      <Row className="container-fluid d-flex align-items-center">
        <Col xs={5}>
          Evidencias que den soporte a tu denuncia
          <div className="text-danger">{message || ''}</div>
        </Col>
        <Col xs>
          {!reRender && (
            <label htmlFor="file" className="btn btn-secondary carga">
              <input
                type="file"
                name="file"
                id="file"
                accept="image/x-png,image/jpeg,application/pdf,.doc,.docx,application/msword,.xlsx,.png"
                ref={fileRef}
                onChange={uploadFile}
                className="d-none btn btn-truper-secondary disabled"
              />
              Agregar archivo &nbsp;
              <FontAwesomeIcon icon={faPlus} />
            </label>
          )}
        </Col>
      </Row>

      <Row className="container">
        <Col xs={{ span: 8, offset: 2 }}>
          <ListGroup as="ul">
            {files.map((file, indexFile) => (
              <ListGroup.Item
                key={indexFile}
                as="li"
                className="d-flex justify-content-between align-items-center pt-0 pb-0 text-break"
              >
                <div className="ms-2 me-auto">{file.name}</div>
                <Button variant="link" onClick={() => removeFile(indexFile)} className="color-primary m-0">
                  <FontAwesomeIcon icon={faTrash} />
                </Button>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Col>
        {!!files.length && !!onUploadAction && (
          <Col xs>
            <Button
              onClick={() => {
                onUploadAction(files);
                resetFiles();
              }}
              className="btn btn-truper btn-md"
            >
              Subir archivos &nbsp;
              <FontAwesomeIcon icon={faUpload} />
            </Button>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default FormTescuchaFiles;
